<template>
    <div class="bg-teal-500 rounded-lg p-5 mt-3 font-poppins">
        <h1 class="text-lg font-bold text-slate-900 mb-5">DATA PENDAFTARAN</h1>
        <table>
            <tr>
                <td width="50%">Tanggal Periksa</td>
                <td width="50%">
                    <span class="font-bold">{{ antrian.FD_TGL_ANTRIAN }}</span>
                </td>
            </tr>
            <tr>
                <td>Kode Booking</td>
                <td>
                    <span class="font-bold">{{
                        antrian.booking.FS_KD_TRS
                    }}</span>
                </td>
            </tr>
            <tr>
                <td>No RM</td>
                <td>
                    <span class="font-bold">{{ antrian.pasien.FS_MR }}</span>
                </td>
            </tr>
            <tr>
                <td>Poliklinik</td>
                <td>
                    <span class="font-bold">{{
                        antrian.poli.FS_NM_LAYANAN
                    }}</span>
                </td>
            </tr>
        </table>
        <table>
            <tr>
                <td>
                    <button
                        @click.prevent="deleteHistory(antrian.FS_KD_TRS)"
                        class="bg-pink-600 hover:bg-pink-800 text-sm text-white rounded-lg h-12 p-5 flex items-center justify-center mt-5 mr-2"
                    >
                        HAPUS
                    </button>
                </td>
                <td>
                    <Link
                        :href="antrian.linkBuktiAntrian"
                        class="bg-teal-600 hover:bg-teal-800 text-sm text-white text-center rounded-lg h-12 p-5 flex items-center justify-center mt-5 mr-2"
                        >BUKTI PENDAFTARAN</Link
                    >
                </td>
                <td>
                    <Link
                        :href="antrian.linkStatusAntrian"
                        class="bg-secondary hover:bg-secondary-dark text-sm text-white text-center rounded-lg h-12 p-5 flex items-center justify-center mt-5"
                        >STATUS ANTRIAN</Link
                    >
                </td>
            </tr>
        </table>

        <!-- <div class="clear-both"></div> -->
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
export default {
    props: {
        antrian: Object,
    },
    components: {
        Link,
    },
    methods: {
        deleteHistory(kd_antrian) {
            const confirm = window.confirm(
                "Yakin Anda akan menghapus data booking tersebut?"
            );
            if (confirm == 1) {
                this.$inertia.post(
                    "/regis/delete/" + kd_antrian,
                    {},
                    {
                        preserveScroll: true,
                        preserveState: true,
                    }
                );
            }
        }
    },
};
</script>
